var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('label',{staticClass:"label"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.surrounding},on:{"input":_vm.switchFacet}}),_vm._v(" "),_c('div',{staticClass:"label-text"},[_vm._v("Surrounding towns?")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }